import slice from "./storeCostActionsSlice";

export default slice.reducer;
